// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { transition, sizes } from "../../helpers/theme";

let logoStyles = props => css`
  width: 100%;
  height: 100%;
  > a {
    display: block;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  svg {
    height: 60%;
    width: auto;
    stop {
      ${transition("all", sizes.timer + "ms")}
    }
  }
`;
let LogoStyled = styled("div")`
  ${logoStyles}
`;

export class Logo extends React.Component {
  render() {
    return (
      <LogoStyled>
        <Link to="/">
          <svg
            version="1.1"
            id="logo-image"
            x="0px"
            y="0px"
            viewBox="0 0 367.4 650"
            style={{ enableBackground: "new 0 0 367.4 650" }}
            xmlSpace="preserve"
          >
            <filter
              id="inset-shadow"
              x="-50%"
              y="-50%"
              width="200%"
              height="200%"
            >
              <feComponentTransfer in="SourceAlpha">
                <feFuncA type="table" tableValues="1 0" />
              </feComponentTransfer>
              <feGaussianBlur stdDeviation={12} />
              <feOffset dx={0} dy={0} result="offsetblur" />
              <feFlood className="LogoColor0" result="color" />
              <feComposite in2="offsetblur" operator="in" />
              <feComposite in2="SourceAlpha" operator="in" />
              <feMerge>
                <feMergeNode in="SourceGraphic" />
                <feMergeNode />
              </feMerge>
            </filter>
            <linearGradient
              id="SVGID_Logo_1_"
              gradientUnits="userSpaceOnUse"
              x1="0%"
              y1="100%"
              x2="100%"
              y2="0%"
              gradientTransform="matrix(1 0 0 -1 0 651)"
            >
              <stop className="LogoColor1" offset="0" />
              <stop className="LogoColor2" offset="1" />
              <animate
                attributeName="x1"
                dur="60s"
                values="0%;100%;100%;0%;0%"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y1"
                dur="60s"
                values="100%;100%;0%;0%;100%"
                repeatCount="indefinite"
              />
              <animate
                attributeName="x2"
                dur="60s"
                values="100%;0%;0%;100%;100%"
                repeatCount="indefinite"
              />
              <animate
                attributeName="y2"
                dur="60s"
                values="0%;0%;100%;100%;0%"
                repeatCount="indefinite"
              />
            </linearGradient>
            <path
              filter="url(#inset-shadow)"
              style={{ fill: "url(#SVGID_Logo_1_)" }}
              d="M97.8,335.7V555l-24.3,14.1V349.9L0,307.5v332.3l171.3-98.9V123.2L0,222.7v56.5L97.8,335.7z M73.5,293.3v-84.8
      l24.3-14.1v113L73.5,293.3z M367.4,166.2l-61,35.6l-12.4-7.3v-113l-24.3,14.1v113l36.7,21.5l61-35.6v233.4l-171.3,98.9V293.3
      l61-35.6l12.4,7.3v191l24.3-14.1V251l-36.7-21.5l-61,35.6v-156l171.3-98.9V166.2z"
            />
          </svg>
        </Link>
      </LogoStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Partials/Logo.js